import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Award, Briefcase, CheckCircle, Target } from 'lucide-react';
import { companyInfo } from '../data/mock';

const About = () => {
  const handleWhatsApp = () => {
    window.open(companyInfo.whatsappLink, '_blank');
  };

  return (
    <div className="min-h-screen bg-[#0f1419] pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              About <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]">WealthOptimizers</span>
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Your trusted partner in building lasting wealth through disciplined, goal-oriented investing
            </p>
          </div>
        </div>
      </section>

      {/* Our Journey */}
      <section className="py-20 bg-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1542744173-05336fcc7ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxmaW5hbmNpYWwlMjBwbGFubmluZ3xlbnwwfHx8fDE3NzAyMzA1ODd8MA&ixlib=rb-4.1.0&q=85"
                alt="Our Journey"
                className="rounded-2xl shadow-xl w-full h-auto border border-gray-800"
              />
            </div>
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Our Journey
              </h2>
              <div className="space-y-4 text-[17px] text-gray-300 leading-relaxed">
                <p>
                  WealthOptimizers was founded with a simple yet powerful vision: to help corporate professionals build lasting wealth through disciplined, goal-oriented investing.
                </p>
                <p>
                  With over 12 years of experience in the financial services industry, working with leading organizations like ICICI Securities, Axis Mutual Fund, Mirae Asset Mutual Fund, and Groww Mutual Fund, we recognized a critical gap - many hardworking professionals lacked access to unbiased, professional financial advice that truly put their interests first.
                </p>
                <p>
                  We built WealthOptimizers on three core pillars: transparency, discipline, and long-term thinking. We believe that wealth creation is not about chasing the next hot stock or timing the market. It's about consistent investing, proper asset allocation, and staying the course through market cycles.
                </p>
                <p>
                  Today, we serve corporate investors across India with a commitment to ethical advisory and regulatory compliance. But more than numbers, what drives us is the trust our clients place in us and the financial security we help them achieve.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gaurav Soni - Founder Profile - PROMINENT SECTION */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
                Led by <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]">Expertise & Experience</span>
              </h2>
              <p className="text-xl text-gray-400">
                12+ years of excellence in wealth management
              </p>
            </div>
            
            <Card className="bg-gradient-to-br from-[#F59E0B]/10 via-[#FBBF24]/10 to-[#F59E0B]/10 border-2 border-[#F59E0B]/50 shadow-2xl shadow-[#F59E0B]/20">
              <CardContent className="p-10 md:p-12">
                <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
                  <div className="w-32 h-32 bg-gradient-to-br from-[#F59E0B] to-[#FBBF24] rounded-2xl flex items-center justify-center text-black font-bold text-5xl shadow-xl shadow-[#F59E0B]/30">
                    GS
                  </div>
                  <div className="text-center md:text-left flex-1">
                    <h3 className="text-4xl font-bold text-white mb-3">Gaurav Soni</h3>
                    <p className="text-2xl text-[#F59E0B] font-semibold mb-4">Founder & Principal Advisor</p>
                    <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-lg text-gray-300">
                      <div className="flex items-center">
                        <Award className="w-6 h-6 mr-2 text-[#F59E0B]" />
                        <span className="font-semibold">12 Years Experience</span>
                      </div>
                      <div className="flex items-center">
                        <Briefcase className="w-6 h-6 mr-2 text-[#F59E0B]" />
                        <span>AMFI Registered Distributor</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mb-10">
                  <h4 className="text-2xl font-bold text-white mb-6 flex items-center">
                    <Briefcase className="w-7 h-7 mr-3 text-[#F59E0B]" />
                    Professional Work Experience
                  </h4>
                  <div className="grid md:grid-cols-2 gap-5">
                    <Card className="bg-[#0f1419] border-2 border-gray-800 hover:border-[#F59E0B] transition-all">
                      <CardContent className="p-6 flex items-center">
                        <div className="w-4 h-4 bg-[#F59E0B] rounded-full mr-4 flex-shrink-0"></div>
                        <div>
                          <h5 className="text-xl font-bold text-white mb-1">ICICI Securities</h5>
                          <p className="text-sm text-gray-400">Wealth Management Professional</p>
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card className="bg-[#0f1419] border-2 border-gray-800 hover:border-[#F59E0B] transition-all">
                      <CardContent className="p-6 flex items-center">
                        <div className="w-4 h-4 bg-[#F59E0B] rounded-full mr-4 flex-shrink-0"></div>
                        <div>
                          <h5 className="text-xl font-bold text-white mb-1">Axis Mutual Fund</h5>
                          <p className="text-sm text-gray-400">Investment Advisory Specialist</p>
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card className="bg-[#0f1419] border-2 border-gray-800 hover:border-[#F59E0B] transition-all">
                      <CardContent className="p-6 flex items-center">
                        <div className="w-4 h-4 bg-[#F59E0B] rounded-full mr-4 flex-shrink-0"></div>
                        <div>
                          <h5 className="text-xl font-bold text-white mb-1">Mirae Asset Mutual Fund</h5>
                          <p className="text-sm text-gray-400">Financial Products Expert</p>
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card className="bg-[#0f1419] border-2 border-gray-800 hover:border-[#F59E0B] transition-all">
                      <CardContent className="p-6 flex items-center">
                        <div className="w-4 h-4 bg-[#F59E0B] rounded-full mr-4 flex-shrink-0"></div>
                        <div>
                          <h5 className="text-xl font-bold text-white mb-1">Groww Mutual Fund</h5>
                          <p className="text-sm text-gray-400">Senior Investment Advisor</p>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </div>
                
                <div className="bg-[#0f1419] p-8 rounded-xl border-2 border-gray-800">
                  <h4 className="text-xl font-bold text-white mb-4">About Gaurav Soni</h4>
                  <p className="text-[17px] text-gray-300 leading-relaxed">
                    AMFI-registered mutual fund distributor with 12 years of comprehensive experience in wealth management. Having worked with leading financial institutions like ICICI Securities, Axis Mutual Fund, Mirae Asset Mutual Fund, and Groww Mutual Fund, Gaurav brings deep industry expertise and a client-first approach to every advisory relationship. Passionate about helping corporate professionals achieve their financial goals through disciplined investing and transparent advice.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <Card className="bg-[#1a1f2e] border-2 border-[#F59E0B]/30 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-10">
                <div className="w-16 h-16 bg-gradient-to-br from-[#F59E0B] to-[#FBBF24] rounded-xl flex items-center justify-center mb-6">
                  <Target className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-3xl font-bold text-white mb-6">Our Mission</h3>
                <p className="text-lg text-gray-300 leading-relaxed">
                  To empower corporate professionals with expert financial guidance, helping them build sustainable wealth through disciplined investing, transparent advice, and long-term partnership.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-[#1a1f2e] border-2 border-[#F59E0B]/30 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-10">
                <div className="w-16 h-16 bg-gradient-to-br from-[#F59E0B] to-[#FBBF24] rounded-xl flex items-center justify-center mb-6">
                  <Award className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-3xl font-bold text-white mb-6">Our Vision</h3>
                <p className="text-lg text-gray-300 leading-relaxed">
                  To be India's most trusted wealth management partner for corporate professionals, known for our integrity, expertise, and unwavering commitment to client success.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Our Core <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]">Values</span>
            </h2>
            <p className="text-xl text-gray-400">
              The principles that guide everything we do
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <Card className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-white">Transparency</h3>
                <p className="text-[17px] text-gray-300 leading-relaxed">
                  Clear, honest communication about products, costs, and expected outcomes. No hidden charges or misleading promises.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-white">Integrity</h3>
                <p className="text-[17px] text-gray-300 leading-relaxed">
                  Putting client interests first, always. We succeed only when our clients achieve their financial goals.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-white">Discipline</h3>
                <p className="text-[17px] text-gray-300 leading-relaxed">
                  Following a structured, process-driven approach to investing that has proven results over the long term.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-white">Long-Term Thinking</h3>
                <p className="text-[17px] text-gray-300 leading-relaxed">
                  Focus on sustainable wealth creation rather than chasing short-term market trends or speculative gains.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-white">Compliance</h3>
                <p className="text-[17px] text-gray-300 leading-relaxed">
                  Adhering to the highest standards of regulatory compliance and ethical conduct in all our operations.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-[#F59E0B]" />
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-white">Excellence</h3>
                <p className="text-[17px] text-gray-300 leading-relaxed">
                  Continuous learning and improvement to provide the best possible service to our clients.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Credentials & Compliance */}
      <section className="py-20 bg-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <Card className="bg-gradient-to-r from-[#F59E0B]/10 to-[#FBBF24]/10 border-2 border-[#F59E0B]/50">
            <CardContent className="p-12 text-center">
              <Award className="w-20 h-20 text-[#F59E0B] mx-auto mb-6" />
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                AMFI Registered & Compliant
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
                As an AMFI-registered mutual fund distributor (ARN: {companyInfo.arn}), we adhere to the highest standards of regulatory compliance and ethical conduct.
              </p>
              <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mt-12">
                <div className="bg-[#1a1f2e] p-6 rounded-xl border border-gray-800">
                  <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] mb-2">12+</div>
                  <div className="text-lg text-gray-400">Years of Experience</div>
                </div>
                <div className="bg-[#1a1f2e] p-6 rounded-xl border border-gray-800">
                  <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] mb-2">All India</div>
                  <div className="text-lg text-gray-400">Service Coverage</div>
                </div>
                <div className="bg-[#1a1f2e] p-6 rounded-xl border border-gray-800">
                  <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] mb-2">100%</div>
                  <div className="text-lg text-gray-400">Compliant</div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Let's Build Your Financial Future Together
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Schedule a consultation to discuss your financial goals with our experienced advisor
            </p>
            <Button
              onClick={handleWhatsApp}
              size="lg"
              className="bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] hover:from-[#D97706] hover:to-[#F59E0B] text-black font-semibold px-10 py-6 text-lg shadow-lg shadow-[#F59E0B]/30"
            >
              Talk to an Expert
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;